<ul (window:resize)="ngAfterContentInit()" class="nav nav-tabs justify-content-center" [ngClass]="{'main-tabs shadow border px-md-3 px-0': main}" id="myTab" role="tablist">
    <ng-content></ng-content>
    <div class="switch-nav-indicator bg-purple"></div>
</ul>
